export const additionalStates = [
    'Uszkodzony',
    'Bezwypadkowy',
    'Pierwszy właściciel',
    'Historia serwisu w ASO',
    'Zarejestrowany jako zabytek',
    'Homologacja ciężarowa',
    'Poleasingowy',
]

export const additionalStatesNames = [
    'uszkodzony',
    'bezwypadkowy',
    'pierwszy-wlasciciel',
    'historia-aso',
    'zabytkowy',
    'homologacja-ciezarowa',
    'poleasingowy',
]

const stanDodatkowy = { name: 'stan-dodatkowy', options: additionalStates, names: additionalStatesNames }
export default stanDodatkowy